import React from 'react';

import { Container, Line, GithubLogo } from './styles';

const Footer = () => {
  return (
    <Container>
      <Line />
      <GithubLogo />
    </Container>
  );
};

export default Footer;
